import { Component } from '@angular/core';
import { SupportsSideMenu } from '../supports-side-menu/supports-side-menu';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-supports-base',
  imports: [SupportsSideMenu, RouterOutlet],
  templateUrl: './supports-base.html',
  styleUrl: './supports-base.scss',
})
export class SupportsBase {}
